import { RootState } from '@/store';
import { GetterTree } from 'vuex';
import { AuthState } from './state';
import { AUTHENTICATION_IS_LOGGED,
         AUTHENTICATION_GET_TOKEN,
         AUTHENTICATION_GET_USER } from './types';

export const getters: GetterTree<AuthState, RootState> = {
  [AUTHENTICATION_IS_LOGGED](state) {
    return state.isLogged;
  },
  [AUTHENTICATION_GET_TOKEN](state) {
    return state.accessToken;
  },
  [AUTHENTICATION_GET_USER](state) {
    return state;
  },
};
